import { type FC } from 'react';
import { GalleryAutoWidth, MediaItemStub } from '@direct-frontend/components';
import styles from './CardsGalleryCards.module.css';

type CardsGalleryCardsStubProps = {
    count?: number;
};

export const CardsGalleryCardsStub: FC<CardsGalleryCardsStubProps> = ({ count = 4 }) => {
    const items = Array.from({ length: count }, (_, index) => {
        return { id: index.toString() };
    });

    return (
        <GalleryAutoWidth
            animationDuration={300}
            itemGapSize="8"
            items={items}
            arrowButtons={{ className: styles.arrowButton }}
            renderItemContent={() => <MediaItemStub caption="stub" height="120px" width="120px" title="stub" />}
        />
    );
};
